var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"43","height":"43","viewBox":"0 0 43 43","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"21.5","cy":"21.5","r":"19.5","stroke":"#0096D6","stroke-width":"4"}}),_c('path',{attrs:{"d":"M13.0186 20.3356L19.2605 26.5775L29.6637 16.1743","stroke":"#0096D6","stroke-width":"4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }